/**
 * @deprecated use same function from '@alilc/lowcode-utils' instead
 */
export function isJSBlock(data) {
  return data && data.type === 'JSBlock';
}